import { render, staticRenderFns } from "./san.vue?vue&type=template&id=1d5db11c&scoped=true&"
import script from "./san.vue?vue&type=script&lang=js&"
export * from "./san.vue?vue&type=script&lang=js&"
import style0 from "./san.vue?vue&type=style&index=0&id=1d5db11c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5db11c",
  null
  
)

export default component.exports